// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2vayk","vLegacy":"SelectSecondary_vLegacy__2jYUA","error":"SelectSecondary_error__27EIm","disabled":"SelectSecondary_disabled__32KTE"};